import React from "react";
import { Box } from "lucide-react";
import { PassiveBadge } from "../ui/data-presentation";

const EMPTY = "-";
const COLUMN_LAYOUT = "grid-cols-[minmax(130px,0.85fr)_minmax(150px,1fr)_minmax(190px,1.15fr)_minmax(180px,1fr)_minmax(180px,1fr)]";

const readable = (value) => {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized || EMPTY;
};

export default function CannibalStockSourceSnapshot({
  cannibalId,
  removedParts = [],
  badge = "Transfer time snapshot",
  testId = "cannibal-stock-source-snapshot",
}) {
  const rows = Array.isArray(removedParts) ? removedParts : [];

  return (
    <section
      className="overflow-hidden rounded-sm border border-warning/60 bg-warning/10 px-4 py-3.5 text-zinc-800 dark:text-zinc-100"
      data-testid={testId}
      aria-labelledby={`${testId}-title`}
    >
      <div className="flex flex-wrap items-center gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-warning/30 bg-warning/15 text-warning" aria-hidden="true">
          <Box className="h-5 w-5" strokeWidth={1.8} />
        </span>
        <h3 id={`${testId}-title`} className="min-w-0 break-words text-sm font-semibold text-warning sm:text-base">
          Cannibal Stock Source (ID : {readable(cannibalId)})
        </h3>
        <PassiveBadge tone="warning">
          {badge}
        </PassiveBadge>
      </div>

      <div className="mt-3 overflow-x-auto" role="table" aria-label="Cannibal Stock Source">
        <div className={`grid min-w-[830px] gap-x-4 ${COLUMN_LAYOUT} text-xs font-medium text-warning`} role="row">
          <div role="columnheader">Origin</div>
          <div role="columnheader">Part Number</div>
          <div role="columnheader">Part Name</div>
          <div role="columnheader">Recipient Ticket</div>
          <div role="columnheader">Recipient SN</div>
        </div>
        <div className="mt-2 min-w-[830px]" role="rowgroup">
          {rows.length ? rows.map((part, index) => {
            const usage = part?.origin === "cannibal_usage";
            return (
              <div
                className={`grid gap-x-4 py-1 ${COLUMN_LAYOUT} text-sm leading-5`}
                data-testid={`${testId}-row`}
                data-origin={part?.origin || "unknown"}
                key={`${part?.usage_id || part?.pre_existing_removed_part_id || part?.origin || "part"}-${index}`}
                role="row"
              >
                <div className="min-w-0 break-words" role="cell">{usage ? "Cannibal Usage" : part?.origin === "pre_existing" ? "Pre-existing" : EMPTY}</div>
                <div className="min-w-0 break-words" role="cell">{readable(part?.part_number)}</div>
                <div className="min-w-0 break-words" role="cell">{readable(part?.part_name)}</div>
                <div className="min-w-0 break-words" role="cell">{usage ? readable(part?.service_ticket_number) : EMPTY}</div>
                <div className="min-w-0 break-words" role="cell">{readable(part?.recipient_serial_number)}</div>
              </div>
            );
          }) : (
            <div className="py-1 text-sm text-muted-foreground" role="row">
              <div role="cell">No transfer snapshot parts.</div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
